/* 🤖 this file was generated by svg-to-ts */
export const matIconOpacity: {
  name: 'opacity';
  data: string;
} = {
  name: 'opacity',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M17.66 8 12 2.35 6.34 8A8.02 8.02 0 0 0 4 13.64c0 2 .78 4.11 2.34 5.67a7.99 7.99 0 0 0 11.32 0c1.56-1.56 2.34-3.67 2.34-5.67S19.22 9.56 17.66 8zM6 14c.01-2 .62-3.27 1.76-4.4L12 5.27l4.24 4.38C17.38 10.77 17.99 12 18 14H6z"/></svg>`
};
